<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>代付模块</el-breadcrumb-item>
        <el-breadcrumb-item>概览</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="header-bar">
      账户概览
    </div>
    <div class="gird">
      <div class="item">
        <div class="title">已开通代付(商户数)</div>
        <div class="num">{{ view.haveOpened }}</div>
      </div>
      <div class="item">
        <div class="title">待审核笔数</div>
        <div class="num">{{ view.toAudit }}</div>
      </div>
      <div class="item">
        <div class="title">账户总余额</div>
        <div class="num">{{ view.overallBalance }}元</div>
      </div>
      <div class="item">
        <div class="title">今日转出笔数</div>
        <div class="num">{{ view.todayTransferOutNumber }}</div>
      </div>
      <div class="item">
        <div class="title">今日转出总额(元)</div>
        <div class="num">{{ view.todayTransferOutTotal }}</div>
      </div>
    </div>
    <div class="echart">
      <el-row :gutter="20">
        <el-col :span="12">
          <div id="myChart1" style="width: 100%;"></div>
        </el-col>
        <el-col :span="12">
          <div id="myChart2" style="width: 100%;"></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import mgr from '../../assets/js/securityapi';
import api from '../../assets/js/apiRequestHandler';
export default {
  data() {
    return {
      sevenout: [],
      sevenin: [],
      view: {}
    };
  },
  mounted() {
    this.getSevenOut();
    this.getSevenIn();
    this.getView();
  },
  methods: {
    async getSevenOut() {
      let header = await mgr();
      api
        .get('/api/Paid/GetSevenDayTransferOutMoney', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {}
        })
        .then(res => {
          if (res.status === 200) {
            this.sevenout = res.data;
            this.getechart1();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    async getSevenIn() {
      let header = await mgr();
      api
        .get('/api/Paid/GetSevenDayInputMoney', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {}
        })
        .then(res => {
          if (res.status === 200) {
            this.sevenin = res.data;
            this.getechart2();
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    async getView() {
      let header = await mgr();
      api
        .get('/api/Paid/GetPaidAccountOverview', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: {}
        })
        .then(res => {
          if (res.status === 200) {
            this.view = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    getechart1() {
      let time = [];
      let data = [];
      for (let i in this.sevenout) {
        time.push(i);
        data.push(this.sevenout[i]);
      }
      let option = {
        title: {
          text: '近7日转出总额',
          subtext: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            dataView: {
              readOnly: false
            },
            magicType: {
              type: ['line', 'bar']
            },
            restore: {},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: time
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}元'
          }
        },
        series: [
          {
            type: 'line',
            data: data
          }
        ]
      };
      let myChart = this.$echarts.init(document.getElementById('myChart1'));
      myChart.setOption(option);
    },
    getechart2() {
      let time = [];
      let data = [];
      for (let i in this.sevenin) {
        time.push(i);
        data.push(this.sevenin[i]);
      }
      let option = {
        title: {
          text: '近7日平台收入',
          subtext: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            dataView: {
              readOnly: false
            },
            magicType: {
              type: ['line', 'bar']
            },
            restore: {},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: time
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}元'
          }
        },
        series: [
          {
            type: 'line',
            data: data
          }
        ]
      };
      let myChart = this.$echarts.init(document.getElementById('myChart2'));
      myChart.setOption(option);
    }
  }
};
</script>

<style scoped>
.gs_container {
  background-color: #fff;
}

.echart {
  margin: 30px 0;
}

#myChart1 {
  width: 100%;
  height: 400px;
  background-color: #fff;
}
#myChart2 {
  width: 100%;
  height: 400px;
  background-color: #fff;
}

.header-bar {
  background-color: #36c6d3;
  color: #fff;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  margin-bottom: 15px;
}

.gird {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: #ddd 1px solid;
  border-bottom: #ddd 1px solid;
  height: 98px;
}

.gird .item {
  border-right: #eee 1px solid;
  width: 20%;
  text-align: center;
}

.gird .item:last-child {
  border-right: none;
}

.gird .item .title {
  font-size: 18px;
  margin-bottom: 5px;
}

.gird .item .num {
  font-weight: bold;
  color: #00c0ef;
}
</style>
